import { httpGetAuthorized } from "components/utils/http";
import useSWRImmutable from "swr/immutable";

export const useStates = (): [states: State[], isLoading: boolean, error: any] => {
    const { data, error, isLoading } = useSWRImmutable(process.env.REACT_APP_STATES_ENDPOINT, httpGetAuthorized);

    return [data, isLoading, error];
};

export interface State {
    id: number;
    abbreviation: string;
    state: string;
    country: string;
}
